import { render, staticRenderFns } from "./order-invoice-simplified.vue?vue&type=template&id=0ee2a17c"
import script from "./order-invoice-simplified.vue?vue&type=script&lang=js"
export * from "./order-invoice-simplified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports